import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, IconButton, Typography } from '@material-ui/core';
import React, { useCallback, useState, useRef } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { BookingDataAPI } from '../../API/BookingDataAPI';
import CircularProgress from '@material-ui/core/CircularProgress';
import DoneIcon from '@material-ui/icons/Done';
const nonSequence = [{
    api: "process",
    label: "Process Data",
    status: null
},
{
    api: "send",
    label: "Send Data",
    status: null
}, {
    api: "booking",
    label: "Booking",
    status: null
},];
const activeSeq = [{
    api: "process",
    label: "Process Data",
    status: null
},
{
    api: "sendaccount",
    label: "Send Accounts",
    status: null
},
{
    api: "sendlocation",
    label: "Send Location",
    status: null
}, {
    api: "sendbank",
    label: "Send Bank",
    status: null
}, {
    api: "sendcontract",
    label: "Send Contract",
    status: null
}, {
    api: "sendasset",
    label: "Send Asset",
    status: null
},
{
    api: "sendcontractasset",
    label: "Send Contract Asset",
    status: null
}, {
    api: "updatecontract",
    label: "Update Contract",
    status: null
},
{
    api: "book",
    label: "Book Application",
    status: null
}
];
const BookingDialog = ({
    open,
    setOpen,
    app
}) => {
    const [bookSatus, setBookStatus] = useState(null);
    const [apiError, setApiError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [sequence, setSequence] = useState([]);

    const handleValidate = async () => {
        try {
            setLoading(true);
            const response = await BookingDataAPI.validateBooking(app?.id);
            let validateError = response.result;
            if (response.error) {
                if (Array.isArray(validateError) && validateError.length > 0)
                    setApiError("Validating Error: " + validateError[0]);
                else if (Array.isArray(validateError) && validateError.length === 0)
                    setBookStatus("validate");
                else
                    setApiError("Validating Error: " + validateError);
                if (Array.isArray(validateError) && validateError[0].includes("Customer Name not matching with Aspire"))
                    setBookStatus("validate"); //Cust name error can be ignored
                throw new Error(validateError);
            }
            else
                setBookStatus("validate");
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }

    }

    const handleSequenceOrder = useCallback((seq, status) => {
        setSequence(pre => pre.map(seqItem => seqItem.api === seq.api ? {
            ...seqItem,
            status
        } : seqItem));
    }, []);

    const handleBooking = useCallback(async () => {
        setApiError(null);
        setBookStatus("book");
        const data = await BookingDataAPI.getCustomSettings();
        let apiList = activeSeq;
        if (data && data[0]?.is_active === 'true') {
            apiList = nonSequence;
        }
        setSequence(apiList);
        try {
            for (let seq of apiList) {
                handleSequenceOrder(seq, "PROGRESS");
                const aspireResp = await BookingDataAPI.generalSequenceBooking(app?.id, seq.api);
                if (aspireResp.error) {
                    let bookError = aspireResp.result;
                    handleSequenceOrder(seq, "FAIL");
                    setApiError(seq.label + " Error : " + bookError);
                    throw new Error(bookError);
                }
                else
                    handleSequenceOrder(seq, "DONE");
            }
        } catch (error) {
            console.error(error);
        }

    }, [app?.id, handleSequenceOrder]);

    const handleClose = useCallback(() => {
        setOpen(false);
        setBookStatus(null);
        setSequence(null);
        setApiError(null);
    }, [setOpen]);

    const closeReload = () => {
        window.location.reload();
    }
    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">

            <DialogTitle id="alert-dialog-title" >
                <Box display="flex" alignItems="center">
                    <Box flexGrow={1} >Booking</Box>
                    {bookSatus !== 'book' && <Box style={{ marginRight: '-20px' }}>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>}
                </Box>
            </DialogTitle>

            <Divider />

            <DialogContent>
                <DialogContentText id="alert-dialog-description" style={{
                    minHeight: "40px", alignItems: 'center',
                    verticalAlign: 'middle',
                    minWidth: '400px',
                    fontSize: 'large'

                }}>
                    {loading ?
                        (<Box style={{ display: 'flex' }}>
                            <Box style={{ width: '30px' }}>
                                <CircularProgress size={30} />
                            </Box>
                            &nbsp;&nbsp;Validating...
                        </Box>)
                        :
                        (bookSatus === 'book' ?
                            (apiError ?
                                <Typography color='error' variant="h7" style={{ margin: 'auto', fontWeight: '100', textAlign: 'center' }}>
                                    {apiError}
                                </Typography>
                                :
                                sequence.map(seq => (
                                    <Box style={{ display: 'flex' }}>
                                        <Box style={{ width: '30px' }}>
                                            {seq.status === 'DONE' && <DoneIcon size={10} />}
                                            {seq.status === 'PROGRESS' && <CircularProgress size={18} />}
                                            {seq.status === 'FAIL' && <CloseIcon size={10} />}
                                        </Box>
                                        {seq.label}
                                    </Box>
                                ))
                            ) :
                            (apiError ?
                                <Typography color='error' variant="h7" style={{ margin: 'auto', fontWeight: '100', textAlign: 'center' }}>
                                    {apiError}
                                </Typography>
                                : "Would you like to validate and proceed?")
                        )
                    }
                </DialogContentText>
            </DialogContent>

            <DialogActions style={{ margin: 'auto', display: 'block' }}>
                {bookSatus === 'book' && apiError &&
                    <Button onClick={handleClose} color="secondary" variant="contained" disabled={bookSatus === null}>
                        Exit
                    </Button>}
                {bookSatus === 'book' && !apiError && sequence[sequence.length - 1]?.status === 'DONE' &&
                    <>
                        <Typography variant="h5" style={{ fontWeight: '400', textAlign: 'center', color: '#357a38' }}> Deal is booked.</Typography>
                        <Button style={{ display: "block", margin: 'auto' }} onClick={closeReload} variant="contained" >
                            Close
                        </Button>
                    </>}
                {bookSatus !== 'book' &&
                    (apiError ?
                        (apiError.includes("Customer Name not matching with Aspire") ?
                            <>
                                <Button onClick={handleClose} color="secondary" variant="contained">
                                    Exit
                                </Button>
                                <Button
                                    onClick={handleBooking}
                                    color="primary"
                                    variant="contained"
                                    disabled={bookSatus !== "validate"}>
                                    Book
                                </Button>
                            </>
                            :
                            <Button onClick={handleClose} color="secondary" variant="contained">
                                Exit
                            </Button>)
                        :
                        <>
                            <Button
                                variant="contained"
                                onClick={handleValidate}
                                color="primary">
                                Validate
                            </Button>
                            <Button
                                onClick={handleBooking}
                                color="secondary"
                                variant="contained"
                                disabled={bookSatus === null}>
                                Book
                            </Button>

                        </>
                    )
                }
            </DialogActions>
        </Dialog >
    );
};

export default BookingDialog;